import React from 'react';
import _ from 'lodash';
import { graphql, withApollo, compose } from 'react-apollo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ClaimWithDocuments } from '../../queries/ClaimWithDocuments';
import mapCPTs from '../../utils/mapCPTs';
import mapConnection from '../../utils/connectionMapper';
import * as messageActions from '../../actions/message-actions';
import { showMessage as showMessageAction } from '../../actions/message-actions';

const documentsContainer = WrappedComponent => props => {
  const claim = props.data.claim;
  const { claimsPassengerTickets } = mapCPTs(claim);
  const passengers = claimsPassengerTickets.map(cpt => ({
    passengerTicket: cpt.passengerTicket,
    documents: mapConnection(cpt.documentsConnection)
  }));
  return (
    <WrappedComponent
      passengers={passengers}
      {...props}
    >
      {props.children}
    </WrappedComponent>
  );
};

const withClaimDocumentsQuery = graphql(ClaimWithDocuments, {
  options: ({ claimId, match, documentType, filterTypes, refetch }) => ({
    variables: {
      id: _.get(match, 'params.id') || claimId,
      filter: {
        types: filterTypes
      }
    },
    pollInterval: refetch
  }),
  notifyOnNetworkStatusChange: true,
  props: ({ data }) => {
    return {
      data
    };
  }
});

const mapDispatchToProps = dispatch => ({
  actions: () => bindActionCreators(messageActions, dispatch),
  showMessage: message => dispatch(showMessageAction(message))
});

export default WrappedComponent =>
  connect(
    null,
    mapDispatchToProps
  )(
    compose(
      withApollo,
      withClaimDocumentsQuery
    )(documentsContainer(WrappedComponent))
  );



// WEBPACK FOOTER //
// ./src/component/Documents/withBasicClaimDocuments.js